<template>
  <b-container
    class="py-5 mb-5 mt-5 d-flex justify-content-center custom-container"
  >
    <VerifyForm :field="$route.params.field" />
  </b-container>
</template>

<script>
import VerifyForm from '@/components/forms/VerifyForm'

export default {
  components: {
    VerifyForm,
  },

  computed: {
    currentRoute() {
      return this.$route.params.field
    },
  },

  created() {
    if (!this.$route.params.field) {
      this.$router.replace({
        name: 'user.settings-page',
        hash: '#account',
      })
    }
  },
}
</script>
